/**
 * Determine whether a file should be treated as text (vs binary).
 *
 * Uses MIME type first, then falls back to a comprehensive extension list.
 * When in doubt, treat as binary — writeBytes handles everything correctly.
 */
export function isTextLike(name: string, mime: string): boolean {
    if (mime.startsWith('text/')) return true
    if (
        mime === 'application/json' ||
        mime === 'application/xml' ||
        mime === 'application/javascript' ||
        mime === 'application/typescript'
    ) return true

    return /\.(md|txt|json|js|ts|tsx|jsx|css|scss|less|html|htm|xml|svg|py|cs|java|go|rs|rb|yaml|yml|toml|sh|bash|zsh|sql|csv|tsv|env|log|cfg|ini|conf|gitignore|dockerignore|editorconfig|prettierrc|eslintrc|c|cpp|h|hpp|swift|kt|r|lua|pl|php|vue|svelte|astro|mdx)$/i.test(name)
}
